import { KA_STATUS_KEYS, type KaStatusKey } from "sj-ui-toolkit/src/constants/assessmentStatus";

// API status codes
export const COMPLETED_STATUS_CODE = "CODE_COMPLETED";
export const INPROGRESS_STATUS_CODE = "CODE_STARTED";
export const NOT_STARTED_STATUS_CODE = "CODE_NOT_STARTED";
export const OVERDUE_STATUS_CODE = "CODE_OVERDUE";

export const STATUS_CODE_MAP: Record<string, KaStatusKey> = {
  CODE_NOT_STARTED: KA_STATUS_KEYS.notStarted,
  CODE_STARTED: KA_STATUS_KEYS.inProgress,
  CODE_COMPLETED: KA_STATUS_KEYS.complete,
  CODE_OVERDUE: KA_STATUS_KEYS.overdue,
  CODE_ARCHIVED: KA_STATUS_KEYS.archived,
  not_started: KA_STATUS_KEYS.notStarted,
  started: KA_STATUS_KEYS.inProgress,
  submitted: KA_STATUS_KEYS.complete,
  archived: KA_STATUS_KEYS.archived,
};

export const DATE_RANGE_OPTIONS = [
  { label: "All time", value: "all" },
  { label: "Last 7 days", value: "7days" },
  { label: "Last 30 days", value: "30days" },
  { label: "Last 90 days", value: "90days" },
  { label: "Last 6 months", value: "6months" },
  { label: "Last year", value: "1year" },
] as const;

export type DateRangeValue = (typeof DATE_RANGE_OPTIONS)[number]["value"];

// Proficiency
export const PROFICIENCY_THRESHOLDS = {
  GROWTH_OPPORTUNITIES: 60,
  PROFICIENCIES: 80,
} as const;

export const PROFICIENCY_COLORS = {
  foundational: "var(--indigo-dataviz-1)",
  intermediate: "var(--indigo-dataviz-2)",
  advanced: "var(--indigo-dataviz-3)",
} as const;

export type ProficiencyLevel = keyof typeof PROFICIENCY_COLORS;

export const resettableStatusCodes = [COMPLETED_STATUS_CODE, INPROGRESS_STATUS_CODE];

// ---------------------------------------------------------------------------
// Learner data types
// ---------------------------------------------------------------------------

export interface LearnerScore {
  directoryUuid: string;
  email: string;
  givenName?: string;
  familyName?: string;
  statusCode: string;
  statusName?: string;
  status?: string;
  scores?: Array<{
    notApplicable: boolean;
    details: { earnedPoints: number; possiblePoints: number };
    topic: { names: string[] };
  }>;
  dueDate?: string | null;
  completedAt?: string | null;
  timeSpent?: string | null;
  examInstanceId?: string;
  programmingLanguage?: string | null;
  isArchived?: boolean;
  // Added by enrichLearnerRows:
  averageScore?: number | null;
  proficiency?: ProficiencyLevel | null;
  resettable?: boolean;
  timeSpentSeconds?: number | null;
  timeSpentFormatted?: string;
}

export interface ReportingLearnerScore {
  directoryUuid: string;
  scores?: LearnerScore["scores"];
  dueAt?: string | null;
  completedAt?: string | null;
  timeSpent?: string | null;
  examInstanceId?: string;
}

export interface SelfInitiatedReportLearner extends ReportingLearnerScore {
  email: string;
  givenName?: string;
  familyName?: string;
  status?: string;
  programmingLanguage?: string;
}

export interface AssessmentData {
  title: string;
  dynamic?: boolean;
  dynamicDays?: number | null;
  learnerStatuses: LearnerScore[];
}

export interface AssignmentScores {
  assignmentScores?: Array<{ learnerScores?: ReportingLearnerScore[] }>;
}

export interface ProficiencyDistribution {
  foundational: number;
  intermediate: number;
  advanced: number;
  inProgress: number;
  notStarted: number;
}

export interface CategoryScore {
  category: string;
  averageScore: number;
}

export interface TopicScore {
  topic: string;
  averageScore: number;
}

export const LINKABLE_STATUSES = ["CODE_COMPLETED", "submitted", "CODE_ARCHIVED", "archived"];
